import { useTranslation } from "react-i18next";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { COMPANY } from "../data/site";

export const WhatsAppFloat = () => {
    const { t } = useTranslation();
    const href = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
        t("whatsapp.float_message"),
    )}`;
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-float"
            aria-label={t("whatsapp.float_aria")}
            className="fixed bottom-20 right-4 z-40 inline-flex items-center justify-center h-14 w-14 bg-[#25D366] text-white hover:bg-[#1FAE53] transition-colors shadow-2xl rounded-full"
        >
            <WhatsAppIcon size={28} />
        </a>
    );
};
